import React, { ReactType } from 'react';
import { IconWrapper } from './Select.styles';

type IconToggleTypes = {
  condition: boolean;
  ifTrue?: ReactType<any>;
  ifFalse?: ReactType<any>;
  className?: string;
};

const IconToggle = ({
  condition,
  ifTrue: TruthyIcon,
  ifFalse: FalsyIcon,
  className = ''
}: IconToggleTypes) => {
  const IconToShow = condition ? TruthyIcon : FalsyIcon;

  return IconToShow ? (
    <IconWrapper className={className}>
      <IconToShow width={10} height={20} />
    </IconWrapper>
  ) : null;
};

export default IconToggle;
